import React, { useState, useEffect } from 'react';

export default function ScheduleTiersModal({ isOpen, onClose, scheduleTiers, presets, onSave }) {
  const [editedTiers, setEditedTiers] = useState(scheduleTiers);

  useEffect(() => {
    if (isOpen) setEditedTiers(scheduleTiers);
  }, [isOpen, scheduleTiers]);

  if (!isOpen) return null;

  const updateTier = (tierKey, field, value) => {
    setEditedTiers(prev => ({
      ...prev,
      preset: 'custom',
      [tierKey]: { ...prev[tierKey], [field]: parseFloat(value) || 0 },
    }));
  };

  const handlePresetChange = (presetName) => {
    if (presets?.[presetName]) {
      setEditedTiers({
        preset: presetName,
        ...presets[presetName].tiers,
      });
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold">Edit Schedule Tiers</h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700">✕</button>
        </div>

        <div className="mb-4">
          <label className="block text-sm font-medium mb-1">Preset</label>
          <select
            value={editedTiers?.preset || 'custom'}
            onChange={(e) => handlePresetChange(e.target.value)}
            className="w-full border rounded px-3 py-2"
          >
            {presets && Object.entries(presets).map(([key, preset]) => (
              <option key={key} value={key}>{preset.label}</option>
            ))}
            <option value="custom">Custom</option>
          </select>
        </div>

        <div className="space-y-4">
          {['tier_1', 'tier_2', 'tier_3', 'tier_4'].map((tierKey, idx) => (
            <div key={tierKey} className="border rounded p-4">
              <h4 className="font-medium mb-2">Tier {idx + 1}</h4>
              <div className="grid grid-cols-3 gap-4">
                <div>
                  <label className="block text-xs text-gray-500">Days Start</label>
                  <input
                    type="number"
                    value={editedTiers?.[tierKey]?.days_start || 0}
                    onChange={(e) => updateTier(tierKey, 'days_start', e.target.value)}
                    className="w-full border rounded px-2 py-1"
                  />
                </div>
                <div>
                  <label className="block text-xs text-gray-500">Days End</label>
                  <input
                    type="number"
                    value={editedTiers?.[tierKey]?.days_end || 0}
                    onChange={(e) => updateTier(tierKey, 'days_end', e.target.value)}
                    className="w-full border rounded px-2 py-1"
                  />
                </div>
                <div>
                  <label className="block text-xs text-gray-500">Interval (hours)</label>
                  <input
                    type="number"
                    step="0.5"
                    value={editedTiers?.[tierKey]?.interval_hours || 0}
                    onChange={(e) => updateTier(tierKey, 'interval_hours', e.target.value)}
                    className="w-full border rounded px-2 py-1"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="flex justify-end gap-2 mt-6">
          <button onClick={onClose} className="px-4 py-2 border rounded hover:bg-gray-50">Cancel</button>
          <button
            onClick={() => { onSave(editedTiers); onClose(); }}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Save Changes
          </button>
        </div>
      </div>
    </div>
  );
}
